import PropTypes from 'prop-types';

import Image from '@plone/volto/components/theme/Image/Image';
import { homepageImageSources } from '../../../helpers/homepageUtils';

const FullwidthImageBody = ({ data }) => {
  const image = homepageImageSources(data?.image, {
    minWidth: 800,
    fallback: 'large',
  });
  const imageAlt =
    data?.alt ||
    (typeof data?.image === 'object' &&
      !Array.isArray(data?.image) &&
      data?.image?.title) ||
    '';

  if (!image.src) {
    return <div className="fullwidth-image-placeholder" />;
  }

  return (
    <div className="mceTmpl image-fullwidth-container">
      <Image
        className="ui image"
        src={image.src}
        srcSet={image.srcSet}
        sizes="100vw"
        width={image.width}
        height={image.height}
        alt={imageAlt}
        fetchpriority="auto"
      />
    </div>
  );
};

FullwidthImageBody.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default FullwidthImageBody;
